import classNames from 'classnames';
import React from 'react';

import withNextConfig from '@tb-core/components/hoc/with-next-config';
import { s3AssetPath } from '@tb-core/helpers/contentful/s3-asset-path';

import styles from './styles.scss';

export interface ImageProps {
    alt?: string;
    assetPath?: string;
    className?: string;
    src: string | null;
    title?: string;
}

// Using a key fixes this bug:
// https://stackoverflow.com/questions/50690956/react-img-not-immediately-changing-when-src-changes-how-can-i-fix-this
const Image = ({
    alt,
    assetPath,
    className,
    src = null,
    title
}: ImageProps) => (
    <>
        {src && (
            <img
                alt={alt}
                className={classNames(styles.image, className)}
                key={src}
                src={
                    src.indexOf('http') !== -1
                        ? src
                        : assetPath + s3AssetPath('/_static/images/', src || '')
                }
                title={title}
            />
        )}
    </>
);

export default withNextConfig(Image);
